module.exports = __webpack_public_path__ + "img/body.f8c10e7d.svg";